<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
-->

<script>

import Vue from 'vue'
import { api } from '@/services/api'

import TransitionWrapper from '@/layout/wrappers/transition-wrapper'
import TheContent from '@/layout/the-content'
import TheHeader from '@/layout/the-header'
import TheMenu from '@/layout/the-menu'
import ThePopup from '@/layout/the-popup'
import TheLoader from '@/layout/the-loader'

export default {

  name: 'App',

  components: {
    TransitionWrapper,
    TheContent,
    TheHeader,
    TheMenu,
    ThePopup,
    TheLoader
  },

  created () {
    if(document.getElementsByClassName('loader__content')[0]){
      document.getElementsByClassName('loader__content')[0].remove();
    }
    this.bindEvents();
    this.setInterceptors()
  },

  computed: {
    isLoading () {
      return this.$store.getters.isLoading
    }
  },

  watch: {
    '$route.path': 'onRouteChange'
  },

  methods: {
    bindEvents () {
      window.addEventListener('resize', () => {
        const width = window.innerWidth
        const height = window.innerHeight

        this.$store.commit('resize', { width, height })
      })

      window.addEventListener('scroll', (event) => {
        if (this.$store.getters.isBlocked) return false

        const scroll = document.body.scrollTop || document.documentElement.scrollTop

        this.$store.commit('scroll', scroll)
      })

      window.addEventListener('DOMMouseScroll', this.onScroll)
      window.addEventListener('mousewheel', this.onScroll)
      window.addEventListener('touchmove', this.onScroll)
      document.body.addEventListener('keydown', this.onKeypress)
      document.addEventListener('click', () => this.$root.$emit('click'))
    },

    setInterceptors () {
      api.interceptors.request.use((request) => {
        if (request.url && !request.url.match(/\/sitemap/i)) {
          request.headers['Accept-Language'] = this.$store.state.app.lang
            ? this.$store.state.app.lang
            : 'ua'
        }

        // if (request.method && request.method.match(/get/i)) {
        //   this.$store.commit('addRequest')
        // }

        return request
      }, (error) => {
        // const response = error.response && error.response.config

        // if (response && response.method.match(/get/i)) {
        //   this.$store.commit('removeRequest')
        // }
      })

      api.interceptors.response.use((response) => {
        // if (response.config.method && response.config.method.match(/get/i)) {
        //   this.$store.commit('removeRequest')
        // }
        return response
      }, (error) => {
        // const response = error.response && error.response.config

        // if (response && response.method.match(/get/i)) {
        //   this.$store.commit('removeRequest')
        // }
      })
    },

    onScroll (event) {
      if (this.$store.getters['app/isBlocked']) {
        event.stopPropagation()
        event.preventDefault()
        event.cancelBubble = false
        return false
      }
    },

    onKeypress (event) {
      this.$root.$emit('keypress', event)
    },

    onRouteChange () {
      this.$store.dispatch('closePopup')
      this.$store.routeChangedFromPopup
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

#app(:class="[$route.name + '-page']")
  router-view.layer-1(:key="$store.state.app.lang")
  the-popup.layer-2
  transition-wrapper(:appear="true")
    the-loader.layer-3(v-if="isLoading")
  transition-wrapper(:appear="true")
    the-header.layer-4(v-if="!isLoading")

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus">

@import 'styles/main.styl'

</style>

<style lang="stylus" scoped>

#app
  display flex
  width 100%
  font-family Gotham
  color dark
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  height 100%
  overflow hidden

.content-container
  display flex
  flex-direction column
  width 100%
  min-height 100vh

.router-view
  display flex
  flex-direction column
  width 100%

.layer-1
  position relative
  z-index 1

.layer-2
  position relative
  z-index 2

.layer-3
  position relative
  z-index 3

.layer-4
  position relative
  z-index 4

// ===========================================
// Animation
// ===========================================

// time = 1s

// .page-enter
// .page-leave-to
//   opacity 0
//   visibility hidden

// .page-enter-active
//   transition opacity time time, visibility time time
// .page-leave-active
//   transition opacity 0s, visibility 0s

</style>



// WEBPACK FOOTER //
// App.vue?9e2fc3b8